// src/components/analyze/BottomActionBar.jsx

import React from 'react';
import { Clipboard, FileText, Play, RefreshCw } from 'lucide-react';

export default function BottomActionBar({
  onPaste,
  onExample,
  onAnalyze,
  loading,
  disabled,
}) {
  return (
    /*
      Bar aksi di bawah FullHeightInput.
      Bukan fixed/absolute, melainkan mengalir secara natural
      di bawah kartu input agar tidak menabrak FloatingNav.
    */
    <div className="px-4 pt-3 pb-2 space-y-3">

      {/* ── Baris Tombol Sekunder ─────────────────────── */}
      <div className="flex gap-2">
        {/* Tempel dari Clipboard */}
        <button
          onClick={onPaste}
          className="
            flex-1 flex items-center justify-center gap-1.5
            bg-white dark:bg-slate-800
            border border-stone-200 dark:border-slate-600
            hover:border-orange-300 hover:bg-orange-50 dark:hover:bg-orange-900/10
            text-slate-600 dark:text-slate-300
            text-xs font-bold
            py-3 rounded-2xl
            transition-all active:scale-95 shadow-soft
          "
        >
          <Clipboard className="w-4 h-4" />
          Tempel
        </button>

        {/* Gunakan Contoh */}
        <button
          onClick={onExample}
          className="
            flex-1 flex items-center justify-center gap-1.5
            bg-white dark:bg-slate-800
            border border-stone-200 dark:border-slate-600
            hover:border-orange-300 hover:bg-orange-50 dark:hover:bg-orange-900/10
            text-slate-600 dark:text-slate-300
            text-xs font-bold
            py-3 rounded-2xl
            transition-all active:scale-95 shadow-soft
          "
        >
          <FileText className="w-4 h-4" />
          Contoh
        </button>
      </div>

      {/* ── Tombol Utama: Bedah I'rab ─────────────────── */}
      <button
        onClick={onAnalyze}
        disabled={loading || disabled}
        className="
          w-full flex items-center justify-center gap-2
          bg-gradient-to-r from-green-500 to-green-600
          hover:from-green-600 hover:to-green-700
          text-white font-extrabold text-sm
          py-4 rounded-3xl
          shadow-soft transition-all
          active:scale-95
          disabled:opacity-40 disabled:cursor-not-allowed disabled:active:scale-100
        "
        style={{
          boxShadow: (!loading && !disabled)
            ? '0 8px 20px rgba(34, 197, 94, 0.30)'
            : undefined,
        }}
      >
        {loading ? (
          <>
            <RefreshCw className="w-5 h-5 animate-spin" />
            <span>Sedang Menganalisis...</span>
          </>
        ) : (
          <>
            <Play className="w-5 h-5 fill-white" />
            <span>Mulai Analisis</span>
          </>
        )}
      </button>

    </div>
  );
}